import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* unfavouriteArticleInfo({ id, callback }) {
  try {
    const response = yield call(api.unfavouriteArticleInfo, id);
    yield put(Actions.unfavouriteArticleInfoSuccess(response?.data));
    if (typeof callback === 'function') {
      yield call(callback);
    }
  } catch (error) {
    yield put(Actions.unfavouriteArticleInfoFail(error));
  }
}

function* watchFavouriteArticlesInfo() {
  yield takeLatest(
    Actions.UNFAVOURITE_ARTICLE_INFO_REQUEST,
    unfavouriteArticleInfo
  );
}

export default function* unfavourite() {
  yield all([fork(watchFavouriteArticlesInfo)]);
}
